import styled from 'styled-components';

const VertLine = styled.span.attrs(({ $height = '16px' }) => ({
    $height,
}))`
    border-left: solid 1px ${({ theme }) => theme.gray_5};
    min-height: ${({ $height }) => $height};
    max-height: ${({ $height }) => $height};
`;

export default VertLine;
